import { RECRUITEE_BACKEND } from '@recruitee/environment/staging';

import { AuthEnvironment } from './interface';

export const environment: AuthEnvironment = {
  environmentName: 'staging',
  angularProdMode: true,
  hmr: false,
  protocol: RECRUITEE_BACKEND.protocol,
  apiAuthUrl: RECRUITEE_BACKEND.authUrl,
};
